const R = 1001, E = 1002, S = 1010, _ = 1011, O = 1012, A = 2e3, N = 2034, I = 2076, C = 2088, o = 2084, t = 2086, D = 2133, c = 2134, n = 2139, s = 2107;
export {
  S as ERROR_AVATAR_UPLOAD_ERROR,
  E as ERROR_GENERAL,
  o as ERROR_SESSION_ACCESS_ALREADY_APPROVED,
  C as ERROR_SESSION_ACCESS_ALREADY_REQUESTED,
  _ as ERROR_SESSION_ACCESS_DENIED,
  t as ERROR_SESSION_ACCESS_DOESNT_EXIST,
  n as ERROR_SESSION_ACCESS_INACTIVE,
  I as ERROR_SESSION_ACCESS_UNAUTHORIZED,
  c as ERROR_SESSION_ACCESS_UNAUTHORIZED_LOCKED,
  D as ERROR_SESSION_ACCESS_UNAUTHORIZED_UNLOCKED,
  O as ERROR_SESSION_IS_FULL,
  N as ERROR_SESSION_NOT_FOUND,
  A as ERROR_SESSION_UNAUTHENTICATED,
  s as ERROR_TRIAL_ALREADY_ACTIVE,
  R as ERROR_UNKNOWN
};
